import React, { useEffect, useState } from "react";
import { StyledContainer, StyledFormPanel, StyledBrandLogo } from "./styled";
import { locale } from "../../utils/LocaleManager";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../components/Button";
import { CircularProgress } from "@mui/material";
import { AuthError, EventType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { getApiAccessToken } from "../../utils/headers";

const LandingScreen = () => {
  const { instance } = useMsal();
  const [success, setSuccess] = useState(false);

  const onLogin = async () => {
    const apiScope = process.env.REACT_APP_API_SCOPE;
    if (!apiScope) {
      toast.error("API access scope is not configured.");
      return;
    }

    try {
      const response = await instance.loginPopup({
        scopes: [apiScope],
      });
      console.log("response", response);

      const account = response.account ?? instance.getAllAccounts()[0];
      if (!account) {
        throw new Error("No account returned from login.");
      }

      instance.setActiveAccount(account);
      await getApiAccessToken(instance, account);
      setSuccess(true);
    } catch (error) {
      console.log("error", error);
      toast.error("API access token acquisition failed.");
      setSuccess(false);
    }
  };

  useEffect(() => {
    if (success) {
      toast.success("Authetication Successful. Redirecting...", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => window.location.assign("/main"),
      });
    }
  }, [success]);

  useEffect(() => {
    const callbackId = instance.addEventCallback((message) => {
      if (message.eventType === EventType.LOGIN_FAILURE) {
        if (message.error instanceof AuthError) {
          const error: AuthError = message.error;
          if (error.errorCode === "user_cancelled") return;
          toast.error(`${error.message}`, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  return (
    <StyledContainer>
      <StyledBrandLogo />
      <StyledFormPanel>
        {success ? (
          <CircularProgress color="secondary" />
        ) : (
          <Button
            variant="contained"
            size="large"
            color="secondary"
            onClick={onLogin}
          >
            {locale.login}
          </Button>
        )}
      </StyledFormPanel>
    </StyledContainer>
  );
};

export default LandingScreen;
